/* Neverover UI fixes - small, additive, globally loaded; each fix self-guards. */
(function () {
  if (window.__nvUiFixes) return;
  window.__nvUiFixes = true;

  /* ===== #3: "See the outfit" (Complete the look) sidebar opens from the WRONG side =====
     The theme's sidebar-component drives the slide with the Web Animations API (so it overrides any
     CSS/inline style), and for this right-direction sidebar it animates to translateX(-100%) - off
     to the LEFT - instead of 0. We hook the open/close click: once the component has settled we
     cancel its stray animation and pin the correct position (flush-right open, off-right closed),
     re-asserting for ~0.5s so we win. Scoped to right-opening "annc" sidebars. */
  function pin(sb) {
    var opened = sb.classList.contains('is-opened');
    try { sb.getAnimations().forEach(function (a) { a.cancel(); }); } catch (e) {}
    sb.style.setProperty('transform', opened ? 'translateX(0)' : 'translateX(100%)', 'important');
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[data-sidebar-button]');
    if (!btn) return;
    var id = btn.getAttribute('data-sidebar-id');
    if (!id) return;
    var sb = document.getElementById(id);
    if (!sb || !sb.matches || !sb.matches('sidebar-component.annc-sidebar[data-open-direction="right"]')) return;
    if (window.matchMedia('(max-width:767px)').matches) return; // mobile: nv-sheets.js turns these into bottom sheets
    [30, 90, 200, 360, 520].forEach(function (d) { setTimeout(function () { pin(sb); }, d); });
  }, true);

  /* ===== #2: product-card colour swatches "+N more" -> expand the grid to all colours =====
     The siblings snippet renders every colour tile; here we show only the first 4 (with the
     "+N more" overlay on the 4th), and clicking that 4th tile reveals the rest (grid grows down,
     overlay disappears). We DON'T force the list open and we leave the grid's overflow:hidden alone,
     so the card's native hover reveal/collapse keeps working: hovering out animates fully closed
     (no leftover swatches, no reserved gap). Hidden tiles are lazy-loaded, so the extra images only
     fetch on expand. */
  var st = document.createElement('style');
  st.textContent =
    '.bottom-image-grid{flex-wrap:wrap!important;}' +
    '.product-card-siblings-list:not(.nv-colors-expanded) .big-grid-item:nth-child(n+5){display:none!important;}' +
    '.product-card-siblings-list.nv-colors-expanded .more-overlay{display:none!important;}' +
    '.big-grid-item:has(.more-overlay){cursor:pointer;}';
  (document.head || document.documentElement).appendChild(st);

  document.addEventListener('click', function (e) {
    var tile = e.target.closest && e.target.closest('.big-grid-item');
    if (!tile) return;
    var list = tile.closest('.product-card-siblings-list');
    if (!list || list.classList.contains('nv-colors-expanded')) return;
    if (!tile.querySelector('.more-overlay')) return; // only the "+N more" tile expands
    e.preventDefault();
    e.stopPropagation();
    list.classList.add('nv-colors-expanded');
  }, true);
})();

;
/* neverover — price reveal on the add-to-cart & checkout buttons, with a subtle count-up.
   • PDP "Add to cart"        → "Add to cart — €24,95"   (selected variant price)
   • Cart-drawer checkout      → "Checkout Securely — €149,00"  (cart subtotal)
   The "— price" part is 50% opacity, counts up briefly on appear/change, is
   HIDDEN while the button's loading spinner is up, and any "tax incl." text is
   stripped. Currency-agnostic. Append to assets/nv-ui-fixes.js. */
(function () {
  var SEP = ' — ';      // separator (' - ' for a plain hyphen)
  var OPACITY = '0.5';
  window.__nvPriceVer = 6; // deploy marker — type __nvPriceVer in the browser console to rule out a cached script

  /* ---- money: strip tax words, parse, re-format ---- */
  function cleanStr(s) {
    return String(s).replace(/ /g, ' ')
      .replace(/\b(incl|including|included|inclus\w*|inkl|taxe?s?|vat|tva)\b\.?/gi, ' ')
      .replace(/[·•|]/g, ' ')
      .replace(/\s{2,}/g, ' ').trim();
  }
  function parseMoney(str) {
    if (str == null) return null;
    str = cleanStr(str);
    var m = str.match(/-?\d[\d.,\s]*\d|\d/); if (!m) return null;
    var token = m[0].replace(/\s/g, '');
    var prefix = str.slice(0, m.index);
    var suffix = str.slice(m.index + m[0].length);
    var decSep = '', decimals = 0, thouSep = '', clean = token;
    var dm = token.match(/[.,](\d{1,2})$/);
    if (dm) {
      decSep = token.charAt(token.length - dm[1].length - 1); decimals = dm[1].length;
      var thou = decSep === ',' ? '.' : ','; if (token.indexOf(thou) !== -1) thouSep = thou;
      clean = token.split(thou).join('').replace(decSep, '.');
    } else { var only = (token.match(/[.,]/) || [])[0]; if (only) { thouSep = only; clean = token.split(only).join(''); } }
    var value = parseFloat(clean); if (isNaN(value)) return null;
    return { value: value, prefix: prefix, suffix: suffix, decimals: decimals, decSep: decSep || ',', thouSep: thouSep };
  }
  function formatMoney(v, f) {
    var neg = v < 0; v = Math.abs(v);
    var parts = v.toFixed(f.decimals).split('.');
    var intp = parts[0];
    if (f.thouSep) intp = intp.replace(/\B(?=(\d{3})+(?!\d))/g, f.thouSep);
    return (neg ? '-' : '') + f.prefix + intp + (f.decimals ? f.decSep + (parts[1] || '') : '') + f.suffix;
  }
  /* read a price element's text WITHOUT nested tax notes (e.g. <span class="extra-tax">Tax Incl.</span>) */
  function priceText(el) {
    if (!el) return null;
    var c = el.cloneNode(true);
    var junk = c.querySelectorAll('.extra-tax, .product-price__tax, .price__tax, .tax-note, .price-item--tax, .unit-price');
    for (var i = 0; i < junk.length; i++) junk[i].remove();
    return c.textContent;
  }

  /* ---- the price span + count-up ---- */
  function ensureSpan(btn) {
    var span = btn.querySelector('.nv-btn-price');
    if (!span) {
      span = document.createElement('span');
      span.className = 'nv-btn-price';
      span.style.opacity = OPACITY;
      span.style.fontVariantNumeric = 'tabular-nums';
      span.style.whiteSpace = 'nowrap';
      var label = btn.querySelector('[data-button-text]');
      if (label && label.insertAdjacentElement) label.insertAdjacentElement('afterend', span);
      else btn.appendChild(span);
    }
    return span;
  }
  function setBtnPrice(btn, f) {
    var span = ensureSpan(btn);
    var t = SEP + formatMoney(f.value, f);
    if (span.textContent !== t) span.textContent = t; // only mutate on real change (prevents observer feedback loops)
  }
  function clearBtn(btn) { var s = btn && btn.querySelector('.nv-btn-price'); if (s) s.textContent = ''; }

  /* ---- hide the price while the button's loading spinner is up ---- */
  function isLoading(btn) {
    var sp = btn.querySelector('.loading-spinner, .btn__loading-spinner, [class*="loading-spinner"]');
    if (sp) { var cs = getComputedStyle(sp); if (cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0.01 && (sp.offsetWidth || sp.offsetHeight)) return true; }
    if (btn.getAttribute('aria-busy') === 'true') return true;
    return /(^|\s)(loading|is-loading|btn--loading|is-busy)(\s|$)/i.test(btn.className || '');
  }
  function applyLoading(btn) { var s = btn.querySelector('.nv-btn-price'); if (s) s.style.display = isLoading(btn) ? 'none' : ''; }
  function watchLoading(btn) {
    if (btn._nvLoad) return; btn._nvLoad = 1;
    new MutationObserver(function () { applyLoading(btn); }).observe(btn, { attributes: true, attributeFilter: ['class', 'aria-busy', 'disabled', 'data-loading'] });
    applyLoading(btn);
  }

  /* ---- PDP add-to-cart ---- */
  var lastPdp = null;
  function readVariantPrice(scope) {
    var form = scope.querySelector('form[action*="/cart/add"]') || scope;
    var idInput = form.querySelector('[name="id"]'); var id = idInput && idInput.value;
    if (id) {
      var tpl = document.querySelector('[data-product-block-template="' + id + '"]');
      if (tpl && tpl.content) { var el = tpl.content.querySelector('.product-price__current-price, .product-price__sale, .price-item'); var t = priceText(el); if (t && t.trim()) return t; }
    }
    var vis = scope.querySelector('.product-price-wrapper .product-price__current-price, .product-price-wrapper .price-item');
    return priceText(vis);
  }
  function updatePDP() {
    var wrap = document.querySelector('.product-price-wrapper'); if (!wrap) return;
    var scope = wrap.closest('.shopify-section') || document;
    var btns = [].slice.call(scope.querySelectorAll('button[name="add"]')); if (!btns.length) return;
    var f = parseMoney(readVariantPrice(scope));
    if (f) lastPdp = f;                 // remember the last valid price
    var show = f || lastPdp;            // use the current read, else fall back to the last known price
    btns.forEach(function (btn) {
      watchLoading(btn);
      if (show) setBtnPrice(btn, show); // always re-assert the price — recreates the span if a variant re-render removed it
    });
  }

  /* ---- cart drawer checkout ---- */
  var lastCart = null;
  function updateCart() {
    var btn = document.querySelector('[data-cart-checkout-button]') || document.querySelector('button[name="checkout"]'); if (!btn) return;
    watchLoading(btn);
    var f = null;
    document.querySelectorAll('.cart-drawer-subtotal__price, .cart-subtotal__price, [data-cart-subtotal]').forEach(function (el) {
      if (!f) { var t = (priceText(el) || '').trim(); if (t) { var pf = parseMoney(t); if (pf && pf.value > 0) f = pf; } }
    });
    if (btn.disabled) { clearBtn(btn); return; }
    if (f) setBtnPrice(btn, f); // empty read → keep last shown total
  }

  /* ---- wire up ---- */
  var p1; function dPDP() { clearTimeout(p1); p1 = setTimeout(updatePDP, 30); }
  var p2; function dCart() { clearTimeout(p2); p2 = setTimeout(updateCart, 30); }
  function boot() {
    updatePDP(); updateCart();
    var pw = document.querySelector('.product-price-wrapper');
    var sec = pw && (pw.closest('.shopify-section') || pw.parentElement);
    if (sec && !sec._nv) { sec._nv = 1; new MutationObserver(dPDP).observe(sec, { subtree: true, childList: true, characterData: true }); } // watch the STABLE section, not the price-wrapper (which gets replaced on variant change)
    ['change', 'click'].forEach(function (ev) { document.addEventListener(ev, function (e) { if (e.target.closest && e.target.closest('variant-picker, variant-selects, .product-variant-picker, .product-form, form[action*="/cart/add"]')) dPDP(); }, true); }); // 'click' catches custom dropdown options that don't fire 'change'
    var cd = document.getElementById('CartDrawer') || document.querySelector('cart-drawer, .cart-drawer');
    if (cd && !cd._nv) { cd._nv = 1; new MutationObserver(dCart).observe(cd, { subtree: true, childList: true, characterData: true, attributes: true }); }
    // fallback: refresh the cart total shortly after any add / cart interaction
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('button[name="add"], [data-cart-checkout-button], cart-drawer, .cart-drawer')) { setTimeout(updateCart, 350); setTimeout(updateCart, 1100); } }, true);
    ['cart:updated', 'cart:refresh', 'cart:change', 'on:cart:add', 'cart:build'].forEach(function (ev) { document.addEventListener(ev, dCart); });
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

;(function () {
  /* neverover — fix helvetica-neue-world's oversized vertical metrics.
     The Adobe "world" variant ships a line box of ~1907/1000em (vs ~1150 for normal fonts),
     lopsided (ascent 1479 / descent 428), so glyphs sit off-center in every fixed-height /
     flex box (buttons, badges, the wishlist count, Klarna text, …). We can't edit Adobe's
     cross-origin @font-face, so we re-declare the kit's rules with balanced metric overrides;
     the last matching @font-face wins, so the override applies to the already-loaded font. */
  try {
    fetch('https://use.typekit.net/udc3tvb.css')
      .then(function (r) { return r.text(); })
      .then(function (css) {
        var blocks = (css.match(/@font-face\s*\{[^}]*\}/gi) || []).filter(function (b) {
          return /font-family:\s*["']?helvetica-neue-world/i.test(b);
        });
        if (!blocks.length) return;
        var ov = 'ascent-override:95%;descent-override:21%;line-gap-override:0%;';
        var st = document.createElement('style');
        st.id = 'nv-font-metric-fix';
        st.textContent = blocks.map(function (b) { return b.replace(/\}\s*$/, ov + '}'); }).join('');
        document.head.appendChild(st);
      })
      .catch(function () {});
  } catch (e) {}
})();

;(function () {
  /* neverover UI overrides:
     1) remove the Y-lift on hover for ALL CTAs (global .btn:hover { transform: translateY(-0.3rem) }).
        Opacity-on-hover is left intact; only the vertical movement is killed.
     2) halve the in-button loading spinner (quick-add, page transitions, etc.): 3rem -> 1.5rem,
        border 2px -> 1px so the ring stays proportional. */
  var css =
    '.btn:hover{transform:none !important;}' +
    '.loading-spinner.btn__loading-spinner{width:1.5rem !important;height:1.5rem !important;border-width:1px !important;}';
  var st = document.createElement('style');
  st.id = 'nv-ui-overrides';
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);
})();

;(function () {
  /* neverover — mobile filter drawer -> bottom sheet: grab handle + drag-to-close (handle AND
     header), backdrop scrim, bordered-X close, "Apply (N)" count, 1rem accordion titles,
     one consistent divider, tighter inner spacing. Plus quick-view drawer button restyle.
     Pure CSS + JS, no Liquid edits. Filter sheet is mobile-only (<768px). */
  if (window.__nvFilterSheet) return;
  window.__nvFilterSheet = true;

  var SB = 'SidebarFiltersMobile';
  var XGLYPH = '✕';
  var EASE = 'transform .36s cubic-bezier(.32,.72,0,1)';

  var css =
  '@media (max-width:767px){' +
    '.sidebar-filters--mobile{position:fixed!important;left:0!important;right:0!important;bottom:0!important;top:auto!important;' +
      'width:100%!important;max-width:100%!important;height:auto!important;max-height:88vh!important;' +
      'border-radius:18px 18px 0 0!important;overflow:hidden!important;box-shadow:0 -10px 34px rgba(20,20,22,.16)!important;' +
      'transform:translateY(100%);transition:transform .36s cubic-bezier(.32,.72,0,1)!important;z-index:8888!important;}' +
    '.sidebar-filters--mobile.is-opened{transform:translateY(0)!important;}' +
    '.sidebar-filters--mobile .sidebar-filters__body{display:flex!important;flex-direction:column!important;width:100%!important;max-width:100%!important;max-height:88vh!important;height:auto!important;}' +
    '.sidebar-filters--mobile .sidebar-filters__content{flex:1 1 auto!important;width:100%!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch;}' +
    '.nv-sheet-scrim{position:fixed;inset:0;background:rgba(20,20,22,.45);opacity:0;visibility:hidden;transition:opacity .32s ease;z-index:8887;}' +
    '.nv-sheet-scrim.is-visible{opacity:1;visibility:visible;}' +
    '.nv-sheet-handle{flex:0 0 auto;width:46px;height:5px;border-radius:99px;background:rgba(20,20,22,.22);margin:11px auto 4px;cursor:grab;touch-action:none;}' +
    '.nv-sheet-handle:active{cursor:grabbing;}' +
    '.sidebar-filters--mobile .sidebar-filters__header{touch-action:none;cursor:grab;padding:6px 20px 12px!important;}' +
    '.sidebar-filters--mobile .sidebar-filters__header .close-button-with-scale-hover{display:none!important;}' +
    '.sidebar-filters--mobile .accordeon__btn{font-size:1.6rem!important;line-height:1.25!important;padding-top:15px!important;padding-bottom:15px!important;}' +
    '.sidebar-filters--mobile .accordeon__content{padding-top:2px!important;padding-bottom:16px!important;}' +
    '.sidebar-filters--mobile .filters__item--bordered{border-bottom:1px solid rgba(20,20,22,.09)!important;border-top:0!important;}' +
    '.sidebar-filters--mobile .filters__item--bordered:last-child{border-bottom:0!important;}' +
    '.sidebar-filters--mobile .filters__btns{gap:12px!important;padding:14px 20px 18px!important;}' +
    '.sidebar-filters--mobile .filters__btns sidebar-button{flex:0 0 54px!important;max-width:54px!important;min-width:54px!important;}' +
    '.sidebar-filters--mobile .filters__btns sidebar-button .filters__btn{width:54px!important;min-width:54px!important;max-width:54px!important;padding:0!important;font-size:0!important;background:transparent!important;border:1px solid rgba(20,20,22,.15)!important;border-radius:12px!important;position:relative;}' +
    '.sidebar-filters--mobile .filters__btns sidebar-button .filters__btn::after{content:"' + XGLYPH + '";font-size:1.6rem;line-height:1;color:#141416;position:absolute;inset:0;display:flex;align-items:center;justify-content:center;}' +
    '.sidebar-filters--mobile .filters__btns filters-submit-btn{flex:1 1 auto!important;border-radius:12px!important;}' +
    '.sidebar-filters--mobile .filters__btns filter-remove-btn{border-radius:12px!important;}' +
  '}' +
  '.drawer-buttons-wrapper{gap:12px!important;}' +
  '.drawer-buttons-wrapper .pdr-close{flex:0 0 54px!important;width:54px!important;min-width:54px!important;max-width:54px!important;padding:0!important;font-size:0!important;background:transparent!important;border:1px solid rgba(20,20,22,.15)!important;border-radius:12px!important;position:relative;}' +
    '.drawer-buttons-wrapper .pdr-close::after{content:"' + XGLYPH + '";font-size:1.6rem;line-height:1;color:#141416;position:absolute;inset:0;display:flex;align-items:center;justify-content:center;}' +
  '.drawer-buttons-wrapper .product-card__btn-wrapper,.drawer-buttons-wrapper .pdr-addtocart{flex:1 1 auto!important;}' +
  '.drawer-buttons-wrapper .pdr-addtocart{border-radius:12px!important;}';

  var st = document.createElement('style');
  st.id = 'nv-filter-sheet';
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  function isMobile(){ return window.matchMedia('(max-width:767px)').matches; }
  function drawer(){ return document.getElementById(SB); }
  function closeControl(d){
    return (d && d.querySelector('.filters__btns sidebar-button [data-sidebar-button]')) ||
           document.querySelector('[data-sidebar-button][data-sidebar-id="' + SB + '"]');
  }
  function realClose(d){
    var b = closeControl(d);
    if (b) b.click(); else if (d) d.classList.remove('is-opened');
  }
  function animateClose(d){
    if (!d || d._nvClosing) return;
    if (!isMobile() || !d.classList.contains('is-opened')) { realClose(d); return; }
    d._nvClosing = true;
    d.style.setProperty('transition','none','important');   // the sheet CSS uses !important — match it
    if (!d.style.transform) d.style.setProperty('transform','translateY(0)','important');
    void d.offsetHeight;
    d.style.setProperty('transition', EASE, 'important');
    d.style.setProperty('transform','translateY(100%)','important');
    showScrim(false);
    var done = false;
    function finalize(){
      if (done) return; done = true;
      d.removeEventListener('transitionend', onEnd);
      d.style.removeProperty('transition');
      d.style.removeProperty('transform');
      d._nvClosing = false;
      realClose(d);
    }
    function onEnd(e){ if (e.target === d && e.propertyName === 'transform') finalize(); }
    d.addEventListener('transitionend', onEnd);
    setTimeout(finalize, 420);
  }
  function closeSheet(d){ animateClose(d); }

  function scrim(){
    var s = document.getElementById('nv-sheet-scrim');
    if (!s){
      s = document.createElement('div'); s.id = 'nv-sheet-scrim'; s.className = 'nv-sheet-scrim';
      (document.body || document.documentElement).appendChild(s);
      s.addEventListener('click', function(){ var d = drawer(); if (d) closeSheet(d); });
    }
    return s;
  }
  function showScrim(on){ scrim().classList.toggle('is-visible', !!on); }

  function updateCount(){
    var d = drawer(); if (!d) return;
    var a = d.querySelector('.filters__btns filters-submit-btn'); if (!a) return;
    var base = a.getAttribute('data-nv-base');
    if (base == null){ base = (a.textContent.replace(/\s*\(\d[\d,\.]*\)\s*$/, '').trim()) || 'Apply'; a.setAttribute('data-nv-base', base); }
    var src = d.querySelector('.filters__results-count');
    var m = src ? (src.textContent.match(/\d[\d,\.]*/) || [])[0] : null;
    var want = m ? (base + ' (' + m + ')') : base;
    if (a.textContent.trim() !== want) a.textContent = want;
  }

  function wireDrag(d, els){
    /* The sheet CSS pins transform/transition with !important, so every inline write here
       MUST use the 'important' priority or the panel won't visibly follow the finger. */
    var startY = 0, dy = 0, dragging = false, lastY = 0, lastT = 0, vel = 0;
    function down(e){
      if (!isMobile()) return;
      dragging = true; dy = 0; vel = 0;
      startY = lastY = (e.touches ? e.touches[0].clientY : e.clientY); lastT = Date.now();
      d.style.setProperty('transition','none','important');
    }
    function move(e){
      if (!dragging) return;
      var y = (e.touches ? e.touches[0].clientY : e.clientY);
      var t = Date.now(); if (t > lastT) vel = (y - lastY) / (t - lastT);
      lastY = y; lastT = t;
      dy = Math.max(0, y - startY);
      d.style.setProperty('transform','translateY(' + dy + 'px)','important');
    }
    function up(){
      if (!dragging) return; dragging = false;
      var h = d.offsetHeight || 600;
      if (dy > h * 0.22 || (dy > 30 && vel > 0.55)){   // far enough OR a quick flick → slide out
        animateClose(d);
      } else {                                          // otherwise snap back open
        d.style.setProperty('transition', EASE, 'important');
        d.style.setProperty('transform','translateY(0)','important');
        var d2 = d;
        var clear = function(ev){
          if (ev && ev.target !== d2) return;
          d2.removeEventListener('transitionend', clear);
          d2.style.removeProperty('transition');
          d2.style.removeProperty('transform');
        };
        d.addEventListener('transitionend', clear);
        setTimeout(function(){ clear(); }, 420);
      }
    }
    els.forEach(function (el){ if (!el) return; el.addEventListener('touchstart', down, { passive: true }); el.addEventListener('mousedown', down); });
    document.addEventListener('touchmove', move, { passive: true });
    document.addEventListener('mousemove', move);
    document.addEventListener('touchend', up);
    document.addEventListener('mouseup', up);
  }

  function addHandle(d){
    var body = d.querySelector('.sidebar-filters__body'); if (!body) return;
    if (body.querySelector('.nv-sheet-handle')) return;
    var h = document.createElement('div'); h.className = 'nv-sheet-handle'; h.setAttribute('aria-hidden', 'true');
    body.insertBefore(h, body.firstChild);
    wireDrag(d, [h, d.querySelector('.sidebar-filters__header')]);
  }

  function onState(){
    var d = drawer(); if (!d) return;
    var open = d.classList.contains('is-opened') && isMobile();
    if (open){ addHandle(d); updateCount(); }
    if (!d._nvClosing) showScrim(open);
  }

  var obs = [];
  function boot(){
    var d = drawer(); if (!d) return;
    obs.forEach(function (o){ try { o.disconnect(); } catch (e) {} }); obs = [];
    try { var o1 = new MutationObserver(onState); o1.observe(d, { attributes: true, attributeFilter: ['class'] }); obs.push(o1); } catch (e) {}
    try { var o2 = new MutationObserver(updateCount); o2.observe(d, { subtree: true, childList: true, characterData: true }); obs.push(o2); } catch (e) {}
    onState();
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
